module.exports = __webpack_public_path__ + "06c117a971fd7bd0dab8a152ec19fb36.pdf";